import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import {
  fullWidth,
  halfWidth,
} from "../../blocks/layout/columnSpans";

/**
 * Communication Activity as page config. A record of an email that was sent, so the
 * page is read-only and its names link to the records they belong to.
 */
export const communicationActivityPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "g4c_communicationactivity",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 9, mobile: 12 },
          // A card that fills the row, so it matches the sidebar's height.
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-details",
              title: "Details",
              fields: [
                {
                  id: "field-scheduledstart",
                  type: "datetime",
                  name: "scheduledstart",
                  label: "Send Date",
                  span: halfWidth,
                },
                {
                  id: "field-g4c_communicationname",
                  type: "text",
                  name: "g4c_communicationname",
                  label: "Communication",
                  span: halfWidth,
                  link: {
                    to: "/email-communication",
                    idKey: "g4c_communication",
                  },
                },
                {
                  id: "field-regardingobjectidname",
                  type: "text",
                  name: "regardingobjectidname",
                  label: "Regarding",
                  span: halfWidth,
                  link: {
                    entityKey: "regardingentityname",
                    routes: {
                      account: "/account",
                      contact: "/contact",
                    },
                    idKey: "regardingobjectid",
                  },
                },
                {
                  id: "field-g4c_test",
                  type: "boolean",
                  name: "g4c_test",
                  label: "Test",
                  span: halfWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 3, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-recipient",
              title: "Recipient",
              fields: [
                {
                  id: "field-g4c_recipientcontactname",
                  type: "text",
                  name: "g4c_recipientcontactname",
                  label: "Contact",
                  span: fullWidth,
                  link: {
                    to: "/contact",
                    idKey: "g4c_recipientcontact",
                  },
                },
                {
                  id: "field-g4c_recipientemailaddress",
                  type: "text",
                  name: "g4c_recipientemailaddress",
                  label: "Email Address",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
